import dayjs from 'dayjs';

/**
 * Tahsilat zamanını yazar — SAAT YALNIZCA GERÇEKTEN BİLİNİYORSA.
 *
 * Bankoda bugüne alınan tahsilatta sunucu gerçek saati kaydediyor
 * (`CompetitionPaymentDeskController::collect`). Ama GERİYE DÖNÜK girişte
 * yönetici yalnızca tarih seçiyor ve sunucu uydurma bir saat yazmak yerine
 * günün başını bırakıyor. O satırlarda "00:00" basmak, olmayan bir bilgiyi
 * varmış gibi göstermek olurdu — kurum gece yarısı tahsilat yapmadığı için
 * 00:00 fiilen "saat bilinmiyor" demek.
 *
 * ⚠ TEK YERDE DURUYOR, iki ekran birden kullanıyor: personelin gördüğü
 * `StudentCompetitionsPanel` ve velinin gördüğü `ParentCompetitions`. Aynı
 * kuralı iki dosyaya kopyalamak bu projede defalarca saptı — biri
 * değiştirilip öteki unutulduğunda veli ile personel aynı ödemeyi farklı
 * zamanda görür ve hangisinin doğru olduğu anlaşılmaz.
 *
 * Değer hem ISO (veli ucu ham modeli serialize ediyor, UTC geliyor) hem
 * `Y-m-d H:i:s` (personel ucu yerel yazıyor) biçiminde gelebiliyor; dayjs
 * ikisini de yerel saate çevirip doğru basıyor.
 */
export const tahsilatZamani = (v) => {
  if (!v) return '—';
  const d = dayjs(v);
  if (!d.isValid()) return '—';
  return d.format('HH:mm') === '00:00'
    ? d.format('DD.MM.YYYY')
    : d.format('DD.MM.YYYY HH:mm');
};

/** Saat bilinmiyor mu — "girildi: ..." ipucunu yalnızca o zaman göstermek için. */
export const saatiYok = (v) => {
  if (!v) return false;
  const d = dayjs(v);
  return d.isValid() && d.format('HH:mm') === '00:00';
};

export default tahsilatZamani;
